export default __webpack_public_path__ + "static/dg-d9d6243052a8efb423939abbf469659e.jpeg";